import postWithToken from './base/post-with-token'

const ArchiveAllAlert = (data) => postWithToken(`/alerts/archive-all`)(data)

export default ArchiveAllAlert
